@if (isLoading()) {
  <app-shimmer-effect />
} @else {

  <section class="page-heading">
  <div>
    <h4>Fees</h4>
    <small>Track payments, balances, and fees</small>
  </div>

  <div class="btn-container">
<!--    @if (isCurrentRoute('/dashboard/student-fees/fee-overview')) {-->
<!--      <button type="button" class="button">-->
<!--        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--          <path d="M6.49951 2.70801V10.2906" stroke="white" stroke-width="1.35404" />-->
<!--          <path d="M2.70801 6.49951H10.2906" stroke="white" stroke-width="1.35404" />-->
<!--        </svg>-->

<!--        <p>Export</p>-->
<!--      </button>-->
<!--    }-->

    @if (isCurrentRoute('/dashboard/student-fees/payments')) {
      <button (click)="setNewPayment.set(true)" type="button" class="button">
        <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="#fff">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <path d="M0 0h48v48H0z" fill="none"></path>
            <g id="Shopicon">
              <path d="M13,4h-3C7.8,4,6,5.8,6,8v23.955c0,2.2,1.8,4,4,4h3V4z"></path>
              <path
                d="M40.228,21.494L30,11.267V8c0-2.2-1.8-4-4-4h-7v31.955h7c2.2,0,4-1.8,4-4v-3.712l2.12,2.12l2.829-2.828l-4.663-4.663 l-6.301-6.301c-0.378-0.378-0.585-0.884-0.584-1.424c0.001-0.534,0.207-1.033,0.584-1.408c0.754-0.755,2.079-0.753,2.832,0 L31,17.923l6.416,6.416l-0.072-0.022l0.109,0.072C37.584,24.586,38,25.337,38,26.955v13H22c-1.915,0-3.605-1.633-3.933-3.799 L18.044,36h-4.045l0.114,0.754c0.621,4.105,4.012,7.201,7.888,7.201h20v-17C42,23.483,40.656,21.907,40.228,21.494z"></path>
            </g>
          </g>
        </svg>

        <p>Record Payment</p>
      </button>
    }

    @if (isCurrentRoute('/dashboard/student-fees/fee-structure')) {
      <button (click)="setFee.set(true)" type="button" class="button">
        <svg fill="#fff" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 293.792 293.792" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <path
            d="M85.671,230.652c20.586-1.138,25.537-2.387,52.067-2.387c0.556,0,1.127,0,1.706,0l0.005-0.041l1.939,0.021l3.593,0.03 l3.042,0.036v-0.006c0.7,0.011,1.429,0.021,2.074,0.025c0.343,0.031,1.246,0.097,2.648,0.087c0.578-0.005,1.229-0.03,1.939-0.076 c3.179-0.203,7.516-0.889,11.938-2.931c8.257-4.041,7.394-12.223,16.097-24.293c13.066-18.128,18.773-23.475,18.967-41.715 c0.106-9.603,0.386-15.679-0.062-20.625l52.826,0.048c4.159,0,7.541-3.417,7.546-7.614l0.046-48.183 c0.011-4.199-3.372-7.622-7.525-7.622l-82.842-0.079h-0.006c-4.148,0-7.53,3.417-7.54,7.615l-0.025,28.708 c0.771,0.82,1.416,1.627,1.919,2.277c0.041,0.051,0.087,0.109,0.127,0.165c0.254-0.094,0.538-0.203,0.812-0.312 c0.925-0.363,1.93-0.784,2.854-1.195l0.01-6.957l86.478,0.079l-0.03,25.504c0,1.046-0.812,1.899-1.818,1.899l-53.816-0.053 l-7.525-0.005c-0.421,0.916-0.944,1.879-1.533,2.856c-0.549,0.924-1.198,1.881-1.92,2.854c-2.122,2.869-5.007,5.918-8.932,9.011 l-1.224,6.713c-0.062,2.214-0.427,4.809-1.361,7.49l-0.284,1.544c-0.574,0.538-7.276,6.819-13.903,11.222 c-0.731,0.488-1.452,0.939-2.174,1.366c-0.771,0.462-1.543,0.894-2.285,1.265c-1.157,0.233-2.422,0.406-3.701,0.406 c-3.956,0-7.942-1.604-8.409-7.871c0,0,2.208-6.855,24.638-20.697c5.814-3.591,9.897-7.147,12.787-10.453 c0.848-0.978,1.584-1.93,2.239-2.856c0.7-0.988,1.295-1.938,1.797-2.854c3.591-6.55,2.61-11.133,2.61-11.133 s0.554-9.359-8.276-9.359c-2.58,0-5.973,0.8-10.405,2.872c0,0-1.351,0.627-2.971,1.31c-0.939,0.394-1.95,0.79-2.854,1.107 c-0.569,0.193-1.097,0.363-1.514,0.457c-0.056,0.01-0.111,0.016-0.162,0.016c-0.371,0-0.767-0.328-1.184-0.774 c-1.727-1.831-4.103-6.452-9.298-6.452c-1.076,0-2.285,0.201-3.636,0.675c-9.602,3.379-3.554,12.5-3.554,12.5 s-13.353-4.228-21.777-4.228c-3.562,0-6.241,0.754-6.67,2.897c-1.438,7.224,0.145,9.983,0.145,9.983s-19.583,0.719-18.121,8.727 c1.459,8.008,4.298,9.079,12.322,9.09c8.023,0.01-37.704,9.444-60.53,29.919c0,0-9.798,7.444-19.027,9.78 c-9.229,2.341,13.561,48.038,13.561,48.038S63.297,231.886,85.671,230.652z M169.838,90.03l0.011-7.081 c0-1.046,0.812-1.899,1.817-1.899l82.842,0.079c1.001,0,1.818,0.858,1.818,1.901l-0.005,7.079L169.838,90.03z"></path> </g> </g> </g></svg>

        <p>Add A Fee</p>
      </button>
    }
  </div>
</section>

<section class="data-cards">
  <div [title]="'GH₵' + feeCards()?.billed" class="data-card academic-year">
    <div class="top-heading">
      <div>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M18 7.36981C16.7435 5.91657 14.9052 5 12.8571 5C9.07005 5 6 8.13401 6 12C6 15.866 9.07005 19 12.8571 19C14.9052 19 16.7435 18.0834 18 16.6302M13 21V3" stroke="#5C0B13" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>      </div>
    </div>

    <h4>GH₵{{ Helpers.formatAmount(feeCards()?.billed) }}</h4>
    <p>Total Billed</p>
    <small>Current term</small>

    <div class="card-bg"></div>
  </div>

  <div [title]="'GH₵' + feeCards()?.collected" class="data-card level">
    <div class="top-heading">
      <div>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.9855 4.49561L6.74347 12.7377L2.99707 8.99128" stroke="#15803D" stroke-width="1.3487"/>
        </svg>
      </div>
    </div>

    <h4>GH₵{{ Helpers.formatAmount(feeCards()?.collected) }}</h4>
    <p>Collected</p>
    <small>Current term</small>

    <div class="card-bg"></div>
  </div>

  <div [title]="'GH₵' + feeCards()?.outstanding" class="data-card term">
    <div class="top-heading">
      <div>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.99133 16.4841C13.1295 16.4841 16.4841 13.1295 16.4841 8.99133C16.4841 4.85317 13.1295 1.49854 8.99133 1.49854C4.85317 1.49854 1.49854 4.85317 1.49854 8.99133C1.49854 13.1295 4.85317 16.4841 8.99133 16.4841Z" stroke="#B45309" stroke-width="1.3487"/>
          <path d="M8.99121 5.99414V8.99126" stroke="#B45309" stroke-width="1.3487"/>
          <path d="M8.99121 11.9885H8.9987" stroke="#B45309" stroke-width="1.3487"/>
        </svg>
      </div>
    </div>

    <h4>GH₵{{ Helpers.formatAmount(feeCards()?.outstanding) }}</h4>
    <p>Outstanding</p>
    <small>Across all levels</small>

    <div class="card-bg"></div>
  </div>


  <div class="data-card subject">
    <div class="top-heading">
      <div>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_284_182)">
            <path d="M7.7103 2.89226L1.36391 13.4871C1.23306 13.7137 1.16382 13.9706 1.16309 14.2322C1.16236 14.4939 1.23015 14.7512 1.35973 14.9785C1.48931 15.2059 1.67615 15.3953 1.90167 15.528C2.12719 15.6607 2.38353 15.732 2.64517 15.7349H15.338C15.5996 15.732 15.8559 15.6607 16.0815 15.528C16.307 15.3953 16.4938 15.2059 16.6234 14.9785C16.753 14.7512 16.8208 14.4939 16.82 14.2322C16.8193 13.9706 16.7501 13.7137 16.6192 13.4871L10.2728 2.89226C10.1393 2.67205 9.95119 2.48999 9.72676 2.36363C9.50233 2.23728 9.24912 2.1709 8.99157 2.1709C8.73401 2.1709 8.48081 2.23728 8.25638 2.36363C8.03195 2.48999 7.84388 2.67205 7.7103 2.89226Z" stroke="#B91C1C" stroke-width="1.3487"/>
            <path d="M8.99121 6.74341V9.74052" stroke="#B91C1C" stroke-width="1.3487"/>
            <path d="M8.99121 12.7378H8.9987" stroke="#B91C1C" stroke-width="1.3487"/>
          </g>
          <defs>
            <clipPath id="clip0_284_182">
              <rect width="17.9827" height="17.9827" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      </div>

    </div>

    <h4>{{ feeCards()?.overdue ?? 0 }}</h4>
    <p>Overdue</p>
    <small>Fees past due date</small>

    <div class="card-bg"></div>
  </div>
</section>

<nav class="page-nav">
  <ul>
    <li routerLinkActive="routerLinkActive" routerLink="fee-overview">OVERVIEW</li>
    <li routerLinkActive="routerLinkActive" routerLink="fee-structure">TUITION & FEES</li>
    <li routerLinkActive="routerLinkActive" routerLink="payments">PAYMENTS</li>
  </ul>
</nav>

<router-outlet />

@if (setFee()) {
  <section class="pop-up">
    <div class="bg" (click)="setFee.set(false)"></div>

    <form #feeForm="ngForm" (ngSubmit)="addFee(feeForm)">
      <div class="form-heading">
        <div class="image-box">
          <svg version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
               viewBox="0 0 32 32" xml:space="preserve" fill="#fff" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier"> <style type="text/css"> .st0 {
              fill: none;
              stroke: #fff;
              stroke-width: 2;
              stroke-linecap: round;
              stroke-linejoin: round;
              stroke-miterlimit: 10;
            } </style>
              <path
                d="M24,16c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S28.4,16,24,16z M27,25h-2v2c0,0.6-0.4,1-1,1s-1-0.4-1-1v-2h-2 c-0.6,0-1-0.4-1-1s0.4-1,1-1h2v-2c0-0.6,0.4-1,1-1s1,0.4,1,1v2h2c0.6,0,1,0.4,1,1S27.6,25,27,25z"></path>
              <g> <path
                d="M16,11c-2.2,0-4,2.2-4,5c0,2.1,1.1,3.9,2.6,4.7c0.9-2.6,2.8-4.7,5.3-5.8C19.5,12.7,17.9,11,16,11z"></path>
                <path
                  d="M31,5H1C0.4,5,0,5.4,0,6v20c0,0.6,0.4,1,1,1h13.5c-0.3-0.9-0.5-2-0.5-3H7c-0.6,0-1-0.4-1-1c0-1.1-0.9-2-2-2 c-0.6,0-1-0.4-1-1v-8c0-0.6,0.4-1,1-1c1.1,0,2-0.9,2-2c0-0.6,0.4-1,1-1h18c0.6,0,1,0.4,1,1c0,1.1,0.9,2,2,2c0.6,0,1,0.4,1,1v3.4 c1.2,0.7,2.2,1.6,3,2.7V6C32,5.4,31.6,5,31,5z"></path> </g> </g></svg>
        </div>

        <div>
          <h6>Add a Fee Type</h6>
          <small>Create a new type of fee</small>
        </div>
      </div>

      <div class="form-container">

        <div>
          <label for="academicYearId">Academic Year <span class="required-check">*</span></label>
          <select (change)="getAcademicTerms(academicYearId)" required [(ngModel)]="academicYearId"
                  name="academicYearId" id="academicYearId">
            <option value="">Select an academic year</option>

            @for (a of academicYears()?.payload; track a.id) {
              <option [value]="a.id">{{ a.name }}</option>
            }
          </select>
        </div>

        @if (academicYearId) {
          <div>
          <label for="academicTermId">Academic Term <span class="required-check">*</span></label>

          <select (change)="selectAcademicTerm(academicTermId)" required [(ngModel)]="academicTermId" type="text" name="academicTermId" id="academicTermId">
            <option value="" hidden disabled>Select a term name</option>

            @for (term of academicTerms()?.payload; track $index) {
              <option [value]="term.id">{{ term.term_name }}</option>
            }
          </select>
        </div>
        }

        <div class="levels-field">
          <label>Select Levels</label>

          <div class="levels-grid">
            <div class="level-option select-all" [class.selected]="areAllLevelsSelected" (click)="selectAllLevels()">
              <div class="level-checkbox">
                @if (areAllLevelsSelected) {
                  <span>✓</span>
                }
              </div>

              <span class="level-name">Select All</span>
            </div>

            @for (level of levels()?.payload; track level.id) {
              <div class="level-option" [class.selected]="selectedLevels.includes(level.id)" (click)="selectLevel(level.id)">
                <div class="level-checkbox">
                  @if (selectedLevels.includes(level.id)) {
                    <span>✓</span>
                  }
                </div>

                <span class="level-name">
          {{ level.name }}
        </span>
              </div>
            }
          </div>
        </div>

        <div>
          <label for="feeName">Name of Fee <span class="required-check">*</span></label>
          <input [(ngModel)]="feeName" type="text" name="feeName" id="feeName" placeholder="e.g. First Term Tuition Fee" list="fee-name-options">

          <datalist id="fee-name-options">
            <option value="JHS First Term Tuition">
            <option value="JHS Second Term Tuition">
            <option value="JHS Third Term Tuition">
            <option value="Primary First Term Tuition">
            <option value="Primary Second Term Tuition">
            <option value="Primary Third Term Tuition">
            <option value="PreSchool First Term Tuition">
            <option value="PreSchool Second Term Tuition">
            <option value="PreSchool Third Term Tuition">
          </datalist>
        </div>

        <div>
          <label for="feeType">Fee Type <span class="required-check">*</span></label>
          <input required [(ngModel)]="feeType" type="text" name="feeType" id="feeType" placeholder="e.g. Academic">
        </div>

        <div>
          <label for="feeAmount">Amount(GH₵) <span class="required-check">*</span></label>
          <input required [(ngModel)]="feeAmount" type="number" name="feeAmount" id="feeAmount" placeholder="550">
        </div>

        <div>
          <label for="feeDueDate">Due date <span class="required-check">*</span></label>
          <input required [(ngModel)]="feeDueDate" type="date" name="feeDueDate" id="feeDueDate">
        </div>

        @if (selectedAcademicTerm) {
          <div class="note">

          <div class="shield-box"><img src="/auth/warning-icon.png" alt="warning image"></div>

          <div>
            <p>Fee due date must fall strictly within the boundaries of the selected Academic Term ({{ Helpers.formatDate(selectedAcademicTerm.term_start_date)}} - {{ Helpers.formatDate(selectedAcademicTerm.term_end_date)}}).</p>
          </div>
        </div>
        }

        <div>
          <label for="feeStatus">Status <span class="required-check">*</span></label>
          <select required [(ngModel)]="feeStatus" name="feeStatus" id="feeStatus">
            <option value="" hidden disabled>Select a status</option>

            @for (s of feeStructureStatuses; track $index) {
              <option [value]="s">{{ Helpers.toSentenceCase(s) }}</option>
            }
          </select>
        </div>

        @if (feeStatus === 'ACTIVE') {
          <div class="checkbox">
          <input [(ngModel)]="feeRequired" type="checkbox" name="feeRequired" id="feeRequired">
          <label for="feeRequired">Required for all students</label>
        </div>
        }

        <button [disabled]="feeForm.invalid || !selectedLevels.length" class="secondary-button" type="submit">
          @if (isEditing()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Add Fee
          }
        </button>

      </div>

    </form>
  </section>
}

@if (setNewPayment()) {
  <section class="pop-up">
    <div class="bg" (click)="setNewPayment.set(false)"></div>

    <form #paymentForm="ngForm" (ngSubmit)="addPayment(paymentForm)">
      <div class="form-heading">
        <div class="image-box">
          <svg version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
               viewBox="0 0 32 32" xml:space="preserve" fill="#fff" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier"> <style type="text/css"> .st0 {
              fill: none;
              stroke: #fff;
              stroke-width: 2;
              stroke-linecap: round;
              stroke-linejoin: round;
              stroke-miterlimit: 10;
            } </style>
              <path
                d="M24,16c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S28.4,16,24,16z M27,25h-2v2c0,0.6-0.4,1-1,1s-1-0.4-1-1v-2h-2 c-0.6,0-1-0.4-1-1s0.4-1,1-1h2v-2c0-0.6,0.4-1,1-1s1,0.4,1,1v2h2c0.6,0,1,0.4,1,1S27.6,25,27,25z"></path>
              <g> <path
                d="M16,11c-2.2,0-4,2.2-4,5c0,2.1,1.1,3.9,2.6,4.7c0.9-2.6,2.8-4.7,5.3-5.8C19.5,12.7,17.9,11,16,11z"></path>
                <path
                  d="M31,5H1C0.4,5,0,5.4,0,6v20c0,0.6,0.4,1,1,1h13.5c-0.3-0.9-0.5-2-0.5-3H7c-0.6,0-1-0.4-1-1c0-1.1-0.9-2-2-2 c-0.6,0-1-0.4-1-1v-8c0-0.6,0.4-1,1-1c1.1,0,2-0.9,2-2c0-0.6,0.4-1,1-1h18c0.6,0,1,0.4,1,1c0,1.1,0.9,2,2,2c0.6,0,1,0.4,1,1v3.4 c1.2,0.7,2.2,1.6,3,2.7V6C32,5.4,31.6,5,31,5z"></path> </g> </g></svg>
        </div>

        <div>
          <h6>Record Payment</h6>
          <small>Add a new fee payment</small>
        </div>
      </div>

      <div class="form-container">

        <div>
          <label for="query">Search Student <span class="required-check">*</span></label>
          <input (input)="getStudents(query)" [(ngModel)]="query" type="search" name="query" id="query"
                 placeholder="Search for a student...">

          @if (students()?.payload?.length && query !== '') {
            <ul>

              @for (s of students()?.payload; track s.id) {
                <li (click)="selectStudent(s)">
                  <h6>{{ s.first_name }} {{ s.last_name }}</h6>
                  <p>School ID: {{ s.public_id }}</p>
                </li>
              }

            </ul>
          }
        </div>

        @if (selectedStudent) {
          <div class="school-card">
            <div class="heading">
              <svg height="24px" width="24px" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg"
                   xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" fill="#fff"
                   stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier"> <style type="text/css"> .st0 {
                  fill: #fff;
                } </style>
                  <g> <path class="st0"
                            d="M366.042,378.266c-26.458-9.72-49.309-18.113-51.793-42.026c-1.149-11.024-0.214-23.982,2.702-37.507 c9.144-9.798,16.72-23.936,24.484-45.691c15.458-5.955,25.31-19.192,30.109-40.442c2.461-10.885-1.058-22.073-9.655-30.807 c0.773-13.206,0.095-13.928-0.402-14.456l-0.542-0.536H151.497v14.914c-9.897,9.115-13.61,19.503-11.038,30.885 c4.794,21.242,14.648,34.48,30.12,40.442c7.762,21.754,15.332,35.885,24.464,45.675c2.06,9.518,4.158,23.61,2.71,37.523 c-2.484,23.913-25.336,32.306-51.795,42.026c-36.32,13.338-77.484,28.462-77.484,88.641C68.474,485.634,126.653,512,256,512 c129.347,0,187.526-26.366,187.526-45.093C443.526,406.729,402.362,391.605,366.042,378.266z M233.908,484.578L203.021,359.12 l37.47,15.598l-2.302,20.66l6.572-0.148L233.908,484.578z M277.101,395.378l-2.302-20.66l37.47-15.598l-30.887,125.458 l-10.854-89.348L277.101,395.378z"></path>
                    <path class="st0"
                          d="M91.083,82.779l54.864,24.13v36.397h222.66v-36.397l22.395-9.852v51.234c-4.75,0.753-8.389,4.728-8.389,9.495 c0,4.146,2.741,7.74,6.704,9.053l-6.378,40.217c-0.421,2.663,0.34,5.357,2.081,7.392c1.739,2.042,4.28,3.214,6.972,3.214h16.792 c2.692,0,5.233-1.172,6.968-3.214c1.745-2.034,2.506-4.728,2.085-7.392l-6.374-40.217c3.969-1.312,6.714-4.907,6.714-9.053 c0-4.767-3.643-8.742-8.397-9.495V88.804l13.686-6.017c2.696-1.172,4.439-3.789,4.439-6.654c0-2.85-1.739-5.458-4.433-6.646 L272.931,3.284C267.987,1.102,262.72,0,257.273,0c-5.446,0-10.712,1.102-15.652,3.284L91.081,69.487 c-2.692,1.188-4.431,3.796-4.431,6.646C86.649,79.006,88.392,81.614,91.083,82.779z"></path> </g> </g></svg>
              <h4>Selected Student</h4>
            </div>

            <div class="school-content">
              <p>STUDENT NAME</p>
              <p>STUDENT ID</p>

              <h5>{{ selectedStudent.first_name }} {{ selectedStudent.last_name }}</h5>
              <h5>{{ selectedStudent.public_id }}</h5>
            </div>
          </div>
        }

        @if (fees()?.payload) {
          <div>
            <label for="studentFeeId">Select Fee <span class="required-check">*</span></label>
            <select required (change)="getStudentPayments(studentFeeId)" name="studentFeeId" id="studentFeeId" [(ngModel)]="studentFeeId">
              <option value="">Choose a fee</option>

              @for (f of fees()?.payload; track $index) {
                <option [value]="f.id">{{ f.fee_name }}</option>
              }
            </select>
          </div>
        }

        @if(paymentRemainingBalance !== null && studentFeeId !== '') {
          <div class="note">

            <div class="shield-box"><img src="/auth/warning-icon.png" alt="warning image"></div>
            <div>
              <h6>Cannot pay more than the Remaining Balance.</h6>
              <p>Remaining Balance: <span>GH₵{{ paymentRemainingBalance }}.</span></p>
            </div>
          </div>
        }

        <div>
          <label for="paymentAmount">Amount (GH₵) <span class="required-check">*</span></label>
          <input required type="number" name="paymentAmount" id="paymentAmount" [max]="paymentRemainingBalance ?? 100000" [(ngModel)]="paymentAmount"
                 placeholder="e.g. 450.50">
        </div>

        <div>
          <label for="paymentDate">Payment Date <span class="required-check">*</span></label>
          <input required type="date" name="paymentDate" id="paymentDate" [(ngModel)]="paymentDate">
        </div>

        <div>
          <label for="paymentMethod">Payment Method <span class="required-check">*</span></label>
          <select required name="paymentMethod" id="paymentMethod" [(ngModel)]="paymentMethod">
            <option value="">Choose a payment method</option>

            @for (p of paymentMethods; track $index) {
              <option [value]="p">{{ Helpers.capitalizeWords(Helpers.replaceUnderscore(p)) }}</option>
            }
          </select>
        </div>

        <div>
          <label for="transactionReference">Transaction Reference</label>
          <input type="text" placeholder="e.g. 48522..." name="transactionReference" id="transactionReference"
                 [(ngModel)]="transactionReference">
        </div>

        <div>
          <label for="additionalNotes">Additional Notes</label>
          <textarea name="additionalNotes" id="additionalNotes" cols="30" rows="2"
                    [(ngModel)]="additionalNotes" placeholder="add relevant notes..."></textarea>
        </div>

        <button [disabled]="paymentForm.invalid || isPaymentOverLimit || !selectedStudent.id || selectedStudent.id === ''" class="secondary-button" type="submit">
          @if (isEditing()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Record Payment
          }
        </button>


      </div>

    </form>
  </section>
}
}
